/**
 * Brand Configuration
 *
 * Single source of truth for all brand-related text.
 * To rebrand: change these values and all UI updates automatically.
 */

export const BRAND = {
  // Primary brand name (used in logos, headers)
  name: 'TrustGate',

  // Display name (may include spaces)
  displayName: 'TrustGate',

  // Tagline
  tagline: 'AI-Native Compliance Platform',

  // Copyright notice (pass current year)
  copyright: (year) => `© ${year} TrustGate. All rights reserved.`,

  // Support info
  support: {
    email: 'support@bytrustgate.com',
  },

  // SDK branding
  sdk: {
    poweredBy: 'Powered by TrustGate',
    securedBy: 'Secured by TrustGate',
  },

  // Page titles
  titles: {
    main: 'TrustGate - Compliance Platform',
    login: 'Login - TrustGate',
    portal: 'Developer Portal - TrustGate',
  },
};

export default BRAND;
